/** How far above a surface's cut its clipped content starts to fade. */
const FADE_PX = 40;

export interface SurfaceFadeProps {
  /**
   * The cut, from the clipping box's top: its foot by default, or a cap
   * (e.g. `"17em"`, the box's `max-height`) so content shorter than the cap
   * shows whole. Ems read the box's own type size.
   */
  at?: string;
}

/**
 * SurfaceFade — where content clipped by a surface (a wall card, a Pinned
 * tile, the code card) meets its cut, the last 40px blend into that
 * surface's own paint: `--surface-fade`, the card paper unless the surface
 * names its own (the code card's ink). Never a mask, which would show what
 * lies behind the surface. The clipping box is `relative overflow-hidden`;
 * the fade is the box's last child.
 */
export function SurfaceFade({ at = "100%" }: SurfaceFadeProps) {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-x-0 z-[1] bg-[linear-gradient(to_bottom,transparent,var(--surface-fade,var(--card-surface)))]"
      style={{ top: `calc(${at} - ${FADE_PX}px)`, height: FADE_PX }}
      data-testid="surface-fade"
    />
  );
}
